/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 13:56:48
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-30 15:21:41
 * @FilePath: \hlweb2.0\src\utils\dictionary.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const general_websiteList = [
  { websiteName: "惠联官网", websiteCode: "HUILIAN" },
];
// moduleCode: 唯一标识
export const general_module_code = {
  HUILIAN: [
    { moduleName: "成功案例", moduleCode: "HL_successStories" },
    { moduleName: "成功案例_英文", moduleCode: "HL_successStories_en" },
    { moduleName: "文化活动", moduleCode: "HL_culturalActivities" },
    { moduleName: "文化活动_英文", moduleCode: "HL_culturalActivities_en" },
    // { moduleName: "合作伙伴", moduleCode: "HL_partners" },
    // { moduleName: "关于我们", moduleCode: "HL_aboutUs" },
  ],
};
export const general_module_type = {
  HL_successStories: [
    "档案数字化服务",
    "档案信息化产品",
    "资产全生命周期管理",
    "空间运营管理数智化",
    "驻场管理",
  ],
  HL_successStories_en: [
    "Archival Digitization Services",
    "Archival Information Technology Products",
    "Asset lifecycle management",
    "Smart digital management of space operations",
    "On-site service",
  ],
  HL_culturalActivities: [
    "公司活动",
    "党建活动",
    "工会活动",
  ],
  HL_culturalActivities_en: [
    "Company Event",
    "Party-building Activities",
    "Union Activities",
  ],
  // HL_partners: [
  //   "数字档案管理",
  //   "信息化服务",
  //   "空间运营归档数智化",
  //   "资产全生命周期管理",
  //   "驻场服务",
  // ],
  // HL_aboutUs: ["文化活动"],
};
export const general_classification_type = {
  HL_successStories: [
    "政府机关",
    "公共事业",
    "金融保险",
    "能源化工",
    "制造业",
    "医疗卫生",
    "教育科研",
    "交通运输",
    "房地产与建筑",
    "文化传媒",
    "法律服务",
    "其他",
  ],
  HL_successStories_en: [
    "government agency",
    "public utilities",
    "financial insurance",
    "Energy and Chemical Industry",
    "manufacturing",
    "medical hygiene",
    "Educational research",
    "transportation",
    "Real Estate and Construction",
    "cultural media",
    "legal services",
    "other",
  ],
  HL_culturalActivities:[],
  HL_culturalActivities_en:[],
  // HL_partners:[],
  // HL_aboutUs:[],
};
